<template>
    <div id="myinfo-fullname">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="fullname"
          name          ="fullname"
          type          ="text"
          class         =""
          placeholder   =""
          :value        ="fullName"
          @input        = "setInputValue($event.target)"
          :label        ="$t('regis-full-name')"
          autocomplete  ="off"
          v-show        ="isShow"
          outline
          floating-label
          required
          :disabled    = "isDisabled"
          :clear-button= "!isDisabled"
        ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      isShow:{
        type: Boolean
      },
      isDisabled:{
        type: Boolean
      },
    },
    mounted (){
      
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('myinfo', [
          'fullName'
      ])
    },
    methods: {
      ...mapActions('myinfo', [
        'setFullname',
        'validateInput'
      ]),

      setInputValue(inputEl){
        this.$emit("setInputValue", inputEl);
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }
    }
  }
</script>